module.exports = __webpack_public_path__ + "static/media/remote.0dbe67b8.svg";